import { defineComponent as _defineComponent } from 'vue'
import { VueMaskFilter } from "v-mask"
import { computed, getCurrentInstance } from "vue"
import { isNavigationFailure } from "vue-router"
import { useRoute, useRouter } from "vue-router/composables"

import i18n from "@/i18n"
import { LOGOUT } from "@/store/modules/auth/actionTypes"

import LanguageSwitcher from "../Common/LanguageSwitcher/LanguageSwitcher.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardHeader',
  setup(__props) {

const proxy = getCurrentInstance()?.proxy as any

const route = useRoute()
const router = useRouter()

const showReturnButton = computed(() => {
  return Boolean(route?.meta?.returnButtonName)
})
const profile = computed(() => proxy.$store.state.user?.profile || {})
const user = computed(() => proxy.$store.state.user?.user || {})
const hasProfile = computed(() => Object.keys(profile.value).length > 0)
const pageTitle = computed(() => {
  const metaTitle = route?.meta?.title

  if (metaTitle && metaTitle === "reviews.title") {
    return i18n.t(metaTitle, [profile.value.name]) || i18n.t("app.title")
  } else if (metaTitle) {
    return i18n.t(metaTitle) || i18n.t("app.title")
  }
})
const phoneNumber = computed(() => user.value.mobile_phone)
const userName = computed(() => user.value.username || proxy.fullName)

const logOut = () => {
  proxy.$store.dispatch("auth/" + LOGOUT)
}
const onReturnButtonClick = async () => {
  try {
    await router.push({ name: route.meta.returnButtonName })
  } catch (error) {
    if (!isNavigationFailure(error)) throw error
  }
}

const formattedPhoneNumber = computed(() => {
  if (!phoneNumber.value) return ""

  return VueMaskFilter(phoneNumber.value, "+## (###) ### ## ##")
})
const syncUrl = computed(() => {
  const url = route.query.url
  return Array.isArray(url) ? url[0] : url
})

return { __sfc: true,proxy, route, router, showReturnButton, profile, user, hasProfile, pageTitle, phoneNumber, userName, logOut, onReturnButtonClick, formattedPhoneNumber, syncUrl, LanguageSwitcher }
}

})